import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { WidgetTicketsDisplayComponent } from '../../../../shared/components/widget-displays/widget-tickets-display/widget-tickets-display.component';
import { SharedModule } from '../../../../shared/shared.module';
import {
  getTicketsLoaded,
  getTicketsLoading,
  getTotalOpenTickets,
  LoadTickets,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-tickets',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetTicketsDisplayComponent, SharedModule],
  template: `
    <app-widget-tickets-display
      [hyperlink]="'/tickets'"
      [queryParams]="{ groupBy: 'Type' }"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [ticketCount]="totalOpenTickets()"
    ></app-widget-tickets-display>
  `,
})
export class WidgetTicketsComponent implements OnInit, OnDestroy {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  private readonly destroy$ = new Subject<void>();

  readonly totalOpenTickets = toSignal<number>(
    this.store.select(getTotalOpenTickets),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getTicketsLoading));

  ngOnInit(): void {
    this.store
      .select(getTicketsLoaded)
      .pipe(takeUntil(this.destroy$))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new LoadTickets());
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
